import { alpha3ToAlpha2 } from "i18n-iso-countries/index.js"
import { parsePhoneNumberWithError, type CountryCode } from "libphonenumber-js"
import { object, string } from "yup"
import { isNilOrEmpty } from "../../util/string"

const numberSchema = string().test(
  "validPhoneNumber",
  "yup.phone.invalid",
  function (value: string | undefined) {
    if (!value) {
      return true
    }

    const countryCode = alpha3ToAlpha2(this.parent.countryCode) as CountryCode

    try {
      const parsedNumber = parsePhoneNumberWithError(value, countryCode)
      return !isNilOrEmpty(parsedNumber) && parsedNumber.isValid()
    } catch {
      return false
    }
  }
)

export const mobilePhoneSchema = object({
  mobileNumber: numberSchema.required(),
  countryCode: string().required(),
})

export const optionalMobilePhoneSchema = object({
  mobileNumber: numberSchema,
  countryCode: string(),
})
